module.exports = __webpack_public_path__ + "img/garwin-pro.5660748c.png";